// src/property-detail.js
import React from 'react';
import ReactDOM from 'react-dom';
import PropertyDetail from './components/PropertyDetail';
document.addEventListener('DOMContentLoaded', function() {
  const propertyDetailContainer = document.getElementById('property-detail-app');
  
  if (propertyDetailContainer) {
    const propertyId = propertyDetailContainer.getAttribute('data-property-id');
    ReactDOM.render(<PropertyDetail propertyId={propertyId} />, propertyDetailContainer);
  }
});